import { getClosedTransactionDetail } from '../../../services/pos/transactions';

export const POS_TRANSACTION_DETAIL_FETCH = 'POS_TRANSACTION_DETAIL_FETCH';
export const POS_TRANSACTION_DETAIL_SUCCESS = 'POS_TRANSACTION_DETAIL_SUCCESS';
export const POS_TRANSACTION_DETAIL_ERROR = 'POS_TRANSACTION_DETAIL_ERROR';


export const getTransactionDetail = (transactionId) => async (dispatch) => {
  dispatch({ type: POS_TRANSACTION_DETAIL_FETCH });
  try {
    const payload = await getClosedTransactionDetail(transactionId);
    dispatch({ type: POS_TRANSACTION_DETAIL_SUCCESS, payload: payload.data });
  } catch (error) {

    let errorCode = 'UNKNOWN_ERROR';
    dispatch({ type: POS_TRANSACTION_DETAIL_ERROR, error: errorCode });
  }
};
